import enums from '@/enums';

/**
 * mixins for v select props
 *
 * @module views/modules/components/v-select-server/v-select-server-props.mixin
 * @author Dilan Useche <dilan8810@gmail.com>
 *
 */
export default {
  props: {
    value: {
      required: true,
    },
    fetchFunction: {
      type: Function,
      required: true,
    },
    header: {
      type: String,
      required: false,
      default: null,
    },
    label: {
      type: String,
      required: false,
      default: 'name',
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    appendToBody: {
      type: Boolean,
      required: false,
      default: false,
    },
    autoscroll: {
      type: Boolean,
      required: false,
      default: false,
    },
    paginationPageSize: {
      type: Number,
      required: false,
      default: 5,
    },
    multiple: {
      type: Boolean,
      required: false,
      default: false,
    },
    placeholder: {
      type: String,
      required: false,
      default: '',
    },
    clearable: {
      type: Boolean,
      required: false,
      default: true,
    },
    taggable: {
      type: Boolean,
      required: false,
      default: false,
    },
    createOption: {
      type: Function,
      required: false,
      default(newOption) {
        if (typeof this.optionList[0] === 'object') {
          // eslint-disable-next-line no-param-reassign
          newOption = { [this.label]: newOption };
        }

        this.$emit('option:created', newOption);
        return newOption;
      },
    },
    selectable: {
      type: Function,
      required: false,
      default: () => true,
    },
    selectOnTab: {
      type: Boolean,
      required: false,
      default: false,
    },
    closeOnSelect: {
      type: Boolean,
      required: false,
      default: false,
    },
    dropdownShouldOpen: {
      type: Function,
      required: false,
    },
    optionEmphasis: {
      type: String,
      required: false,
      default: '',
    },
    manageRouteName: {
      type: String,
      required: false,
      default: '',
    },
    manageText: {
      type: String,
      required: false,
      default: '',
    },
    showCreate: {
      type: Boolean,
      required: false,
      default: false,
    },
    createText: {
      type: String,
      required: false,
      default: '',
    },
    filterBy: {
      type: Function,
      default(option, label, search) {
        return (label || '').toLocaleLowerCase().indexOf(search.toLocaleLowerCase()) > -1;
      },
    },
    filtersMatch: {
      type: String,
      required: false,
      default: enums.AppFilterMathType.ALL,
      validator(value) {
        return Object.values(enums.AppFilterMathType).includes(value);
      },
    },
    filterParams: {
      type: Object,
      required: false,
      default() {
        return {};
      },
    },
    searchFilters: {
      type: Object,
      required: false,
      default() {
        return {};
      },
    },
    useDefaultSearchFilters: {
      type: Boolean,
      required: false,
      default: true,
    },
    sortByField: {
      type: String,
      required: false,
      default: 'createdAt',
    },
    sortByOrder: {
      type: String,
      required: false,
      default: enums.AppSortBy.DESC,
      validator(val) {
        return [
          enums.AppSortBy.ASC,
          enums.AppSortBy.DESC,
        ].indexOf(val) !== -1;
      },
    },
    defaultOptions: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
    permissionToManage: {
      type: String,
      required: false,
      default: '',
    },
    manageRedirectOnlyEvent: {
      type: Boolean,
      required: false,
      default: false,
    },
    searchOnKeyUp: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
